import { AbstractControl } from '@angular/forms';
import { WeekDayFlags } from 'src/app/base/models/models.swagger.generated';
import { MultiFieldDurationPickerHelper } from 'src/app/base/shared/multi-field-duration-picker/multi-field-duration-picker-helper';
import { WeekDayFlagsHelper } from 'src/app/base/shared/utils/week-day-flags.helper';

export class TariffDetailsValidators {
  public static noOverlappingTimeWindows(c: AbstractControl) {
    const values = c.value;
    const durationInHours = MultiFieldDurationPickerHelper.calculateTotalMinutes(
          values?.durationForm?.days, values?.durationForm?.hours, values?.durationForm?.minutes, false) / 60;
    const weekDayFlags = WeekDayFlagsHelper.daysToFlag(values.weekdays);
    if (durationInHours <= 24 || !values.startTime || weekDayFlags < WeekDayFlags.Monday) {
      return null;
    }
    // make sure windows do not overlap each other
    const daysGap = Math.floor(durationInHours / 24);
    let dayFlag = WeekDayFlags.Sunday;
    do
    {
        dayFlag = WeekDayFlagsHelper.shiftFlagsOneDayForward(dayFlag);
        if (WeekDayFlagsHelper.hasFlags(weekDayFlags, dayFlag))
        {
            let gapDay = WeekDayFlagsHelper.shiftFlagsOneDayForward(dayFlag);
            for (let i = 0; i < daysGap; i++)
            {
                if (WeekDayFlagsHelper.hasFlags(weekDayFlags, gapDay))
                {
                    return { timeWindowOverlap: true };
                }
                gapDay = WeekDayFlagsHelper.shiftFlagsOneDayForward(gapDay);
            }
        }
    } while (dayFlag !== WeekDayFlags.Sunday);
    return null;
  }
}
